<template>
  <v-timeline-item
    class="timeline-item-animated"
    :style="{ 'animation-delay': (index * 0.05) + 's' }"
    :color="location.anomaly ? 'error' : 'primary'"
    :icon="location.anomaly ? 'fas fa-exclamation-triangle' : 'fas fa-map-marker-alt'"
    fill-dot
    small
  >
    <v-card @click="details_open = !details_open" class="elevation-2 timeline-card" style="cursor: pointer;" :class="{'red lighten-5': location.anomaly}">
      <v-card-title class="text-subtitle-1 font-weight-bold pb-1 pt-3 d-flex justify-space-between align-center">
        <span class="primary--text">{{ locationTime }}</span>
        <div>
          <v-btn v-if="editMode" icon color="primary" @click.stop="$emit('edit', location)">
            <i class="fal fa-edit"></i>
          </v-btn>
          <v-btn v-if="editMode" icon color="error" @click.stop="$emit('delete', location)">
            <i class="fal fa-trash"></i>
          </v-btn>
          <i :class="!details_open ? 'fad fa-chevron-down' : 'fad fa-chevron-up'" class="grey--text text--darken-1 ml-2"></i>
        </div>
      </v-card-title>
      <v-card-text class="pb-3">
        <div class="text-body-1 font-weight-medium grey--text text--darken-3">{{ location.data.address }}</div>
        <v-expand-transition>
          <div class="point_details mt-3" v-if="details_open">
            <div class="text-caption grey--text mb-2">
              <i class="fas fa-map-marker-alt mr-1"></i> {{ location.data.lat }}, {{ location.data.lon }}
            </div>
            <div v-if="location.anomaly" class="error--text mt-2 font-weight-medium pa-2 rounded-lg" style="background-color: rgba(255,82,82,0.1);">
              <i class="fas fa-exclamation-circle mr-1"></i>
              Anomaly detected! This point is completely somewhere else. We suggest deleting it.
            </div>
          </div>
        </v-expand-transition>
      </v-card-text>
    </v-card>
  </v-timeline-item>
</template>

<script>
export default {
  props: {
    location: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    isRange: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      details_open: false
    };
  },
  computed: {
    locationTime() {
      var start_time = this.parseTime(this.location.data.time);

      return start_time;
    },
  },
  methods: {
    parseTime(timestamp) {
      var date = new Date(parseInt(timestamp) * 1000);
      var timeStr = (date.getHours() + "").padStart(2, "0") +
        ":" +
        (date.getMinutes() + "").padStart(2, "0");
        
      if (this.isRange) {
        var months = [
          this.$t("general.month.january") || "January",
          this.$t("general.month.february") || "February",
          this.$t("general.month.march") || "March",
          this.$t("general.month.april") || "April",
          this.$t("general.month.may") || "May",
          this.$t("general.month.june") || "June",
          this.$t("general.month.july") || "July",
          this.$t("general.month.august") || "August",
          this.$t("general.month.september") || "September",
          this.$t("general.month.october") || "October",
          this.$t("general.month.november") || "November",
          this.$t("general.month.december") || "December",
        ];
        var dateStr = date.getDate() + ". " + months[date.getMonth()];
        return dateStr + ", " + timeStr;
      }
      return timeStr;
    },
  },
};
</script>

<style scoped>
.point_details {
  padding-top: 10px;
}

.timeline-card {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-radius: 16px !important;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.timeline-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.08) !important;
}

@keyframes slideUpFade {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.timeline-item-animated {
  animation: slideUpFade 0.6s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}
</style>